import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Emplado } from './empleado';


@Injectable({
  providedIn: 'root'
})
export class EmpleadoService {


  constructor(private http: HttpClient) { }

 
  getEmpleado(idEmisor: string) {  
    
    return this.http.get<Emplado[]>(environment.apiUrl+"/listarEmpleado/?idEmisor=" + idEmisor);  
  }  

  getVendedor(id:string) {  
  
    return this.http.get<Emplado[]>(environment.apiUrl+"/buscarEmpleadoPorId/?id="+id);  
  }  


  setActulizarPersona(Vendedores: Emplado[]){
    console.log(Vendedores);
    return this.http.put<string>(environment.apiUrl+"/actulizarPersona",Vendedores);
  }


  setActulizarEmpleado(Vendedores: Emplado[]){
    console.log(Vendedores);
    return this.http.put<string>(environment.apiUrl+"/actulizarEmpleado",Vendedores);
  }

  eliminarEmpleado(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarEmpleado/?id="+id);
  }
  




}
